import { render } from "./SellUsYourVehicle.vue?vue&type=template&id=c905d9f0&lang=true"
import script from "./SellUsYourVehicle.vue?vue&type=script&lang=js"
export * from "./SellUsYourVehicle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__